/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box, Heading, Container} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Region, regionPropType} from '@salesforce/commerce-sdk-react/components'

/**
 * This layout component displays its children in a 2 row x 1 column grid on mobile
 * and a 1 row x 2 column grid on desktop.
 *
 * @param {componentProps} props
 * @param {regionType []} props.regions - The page designer regions for this component.
 * @param {object} props.data - The data for the component.
 * @param {string} props.typeId - A mapping of typeId's to react components representing the type.
 * @returns {React.ReactElement} - Grid component.
 */

const customAlignment = {
    '.container': {
        display: 'flex',
        flexDirection: {base: 'column', sm: 'row'},
        margin: {base: '0 10%', sm: '0 10%'}
    }
}

export const popularCategories = ({regions, textHeadline}) => (
    <Container pb="30">
        <Box position={'relative'} width={'full'} overflow={'hidden'}>
            <Text as="figcaption">
                {textHeadline && (
                    <Box className={'image-with-text-heading-container'}>
                        <Heading
                            textAlign="center"
                            fontWeight="400"
                            fontSize="1.5rem"
                            as="h3"
                            m="1em 0 1rem"
                        >
                            {textHeadline}
                        </Heading>
                    </Box>
                )}
            </Text>
            <Box sx={customAlignment}>
                {regions.map((region) => (
                    <Region key={region.id} region={region} />
                ))}
            </Box>
        </Box>
    </Container>
)

popularCategories.displayName = 'popularCategories'

popularCategories.propTypes = {
    // Internally Provided
    regions: PropTypes.arrayOf(regionPropType).isRequired,
    textHeadline: PropTypes.string
}

export default popularCategories
